import AnalysisReportAPI from '@/api/AnalysisReportAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	getAnalysisReport: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${AnalysisReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/request`,
				data: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateAnalysisReportData', {
				...payload,
				TimeLastest: new Date()
			});
			// Lưu filter request gần nhất
			context.commit('updateLastRequestFilter', {
				...payload
			});
		}
		return res;
	},

	getLatestAnalysisReportHistory: async function(context) {
		let res = await httpClient.getAsync({
			url: `${AnalysisReportAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/latest`
		});
		if (res && res.Success && res.Data) {
			context.commit('updateLatestAnalysisReportHistory', res.Data);
			return res.Data;
		}
		return null;
	}
};
